import script from "./qxdj.vue?vue&type=script&setup=true&lang=js"
export * from "./qxdj.vue?vue&type=script&setup=true&lang=js"

import "./qxdj.vue?vue&type=style&index=0&id=285b1000&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285b1000"]])

export default __exports__